import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { EventStatus } from 'routes/referral/types/event-detail-api.types';

import { GlassBox } from 'components/glassBox/GlassBox';

import { getStatusColor } from '../utils';
import styles from './CustomGlassBox.module.scss';

type CustomGlassBoxProps = {
  children: React.ReactNode;
  wrapperClassName?: string;
  className?: string;
  borderRadius?: string;
  status?: EventStatus;
};

export const CustomGlassBox = ({
  children,
  wrapperClassName,
  className,
  borderRadius,
  status,
}: CustomGlassBoxProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const defaultGradient = 'linear-gradient(to bottom right, #2D5EFF 0%, rgba(45, 94, 255, 0.4) 100%)';
  const statusColorObject = status ? getStatusColor(status) : null;
  const statusColor = statusColorObject?.color || '#2D5EFF';
  const shadowVariant = statusColorObject?.shadowVariant;
  const gradient = isHovered && status ? statusColor : defaultGradient;

  return (
    <div
      className={twMerge(styles.wrapper, wrapperClassName)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <GlassBox
        gradient={gradient}
        borderWidth="1px"
        className={className}
        borderRadius={borderRadius}
        shadowVariant={shadowVariant}
      >
        {children}
      </GlassBox>
    </div>
  );
};
